module.exports = __webpack_public_path__ + "img/6.f58e1c51.png";